import React from "react";
import clsx from "clsx";
import LoginHeader from "./components/LoginHeader.js";
import SideNavigation from "./components/SideNavigation.js";
import containerTheme from './theme/containerTheme.js'
import { useState, useEffect } from "react";
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { appInsights } from './AppInsights';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import { useNavigate } from "react-router-dom";
import { PieChart, Pie, Cell, ResponsiveContainer,LabelList,Label } from 'recharts';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';
import { LineChart, Line, Legend} from 'recharts';
import WorldMap from "react-svg-worldmap";
import AADHeader from "./components/AADHeader.js";
export default function Home() {
  const username = localStorage.getItem('userName');
  const companyid = localStorage.getItem('companyid');
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const [responseConfig, setResponseConfig] = useState({});
  const [legal, setLegal] = useState("");
  const [business, setBusiness] = useState("");
  const [site, setSite] = useState("");
  const [year, setYear] = useState("");
  const [country, setCountry] = useState("");
  const [employee, setEmployee] = useState("");
  const [social, setSocial] = useState("");
  const [yearr, setYearR] = useState("");
  const [countries, setCountries] = useState();
  const [businessunit, setBusinessUnit] = useState();
  const [activesite, setActiveSite] = useState();
  const [activeetities, setActiveEntities] = useState();

  function truncateText(text, maxLength) {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + '...';
    }
    return text;
  }

  const handleChatClick = () => {
    navigate('/ChatPage');
  };
  const getOpen = (open) => {
    console.log(open);
    setIsOpen(open);
  };

  async function fetchEntities() {
    var myHeaders = new Headers();
    myHeaders.append("username", username);

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };
    try {
      const response = await fetch('https://ecoprism-prod-node.azurewebsites.net/list-entities',requestOptions);
      if (response.status === 200) {
        const responseJson = await response.json();
        if(responseJson.success == false){
          console.log(responseJson);
          setActiveEntities("");
        }
        else if(responseJson.status == 400){
          setActiveEntities("");
        }
        else{
          setActiveEntities(responseJson.data.filter((item) => item.isActive === true));
        }
      }
      else{
        setActiveEntities("");
      }
    } catch (error) {
      console.error(error);
    }
  }
  async function fetchSite() {
    var myHeaders = new Headers();
    myHeaders.append("username", username);

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };
    try {
      const response = await fetch('https://ecoprism-prod-node.azurewebsites.net//list-sitelocation',requestOptions);
      if (response.status === 200) {
        const responseJson = await response.json();
        if(responseJson.success == false){
          console.log(responseJson);
          setActiveSite("");
        }
        else if(responseJson.status == 400){
          setActiveSite("");
        }
        else{
          setActiveSite(responseJson.data.filter((item) => item.isActive === true));
        }
      }
      else{
        setActiveSite("");
      }
    } catch (error) {
      console.error(error);
    }
  }

  async function fetchBusinessUnit() {
    var myHeaders = new Headers();
    myHeaders.append("username", username);

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };
    try {
      const response = await fetch('https://ecoprism-prod-node.azurewebsites.net//list-businessunits',requestOptions);
      if (response.status === 200) {
        const responseJson = await response.json();
        if(responseJson.success == false){
          setBusinessUnit("");
        }
        else if(responseJson.status == 400){
          setBusinessUnit("");
        }
        else{
          setBusinessUnit(responseJson.data.filter((item) => item.isActive === true));
        }
      }
      else{
        setBusinessUnit("");
      }
    } catch (error) {
      console.error(error);
    }
  }
  async function fetchData() {
    try {
      const response = await fetch('https://ecoprism-prod-node.azurewebsites.net/countries');
      const data = await response.json();
      setCountries(data);
    } catch (error) {
      console.error(error);
    }
  }
  async function fetchSocial() {
    try {
      var myHeaders = new Headers();
      myHeaders.append("username", username);
      myHeaders.append("companyid", companyid);
      myHeaders.append("country", encodeURIComponent(country));
      myHeaders.append("site", site);
      myHeaders.append("year", year);
      myHeaders.append("employee", employee);
      var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };
      console.log(requestOptions);
      console.log(country);
      const response = await fetch('https://ecoprism-prod-node.azurewebsites.net/social', requestOptions);
      const responseJson = await response.json();
      if (responseJson.success === false || responseJson.status === 400) {
      } else {
        setSocial(responseJson.data.value);
        //console.log(responseJson.data.value);
        const parts = responseJson.data.value.genderDistribution.split('; ');
        const result = parts.map(part => part.split(':').pop()).join(':');
        setYearR(result);
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    appInsights.trackPageView();
    fetchSocial();
    fetchData();
    fetchBusinessUnit();
    fetchSite();
    fetchEntities();
    if (country !== "" || year !== "" || site !== "" || business !== "" || legal !== "") {
      fetchSocial();
    }
  }, [country,year,site,business,legal]);
    
      const data_age = [
        { name: '<30', value: social?.employeeAgeDistribution?.below30 || 0 },
        { name: '30-50', value: social?.employeeAgeDistribution?.between30And50 || 0},
        { name: '>50', value: social?.employeeAgeDistribution?.above50 || 0},
      ];

      // Filter out data with value 0
      const filteredData = data_age.filter(entry => entry.value !== 0);
      
      const COLORS = ['#0088FE', '#00C49F', '#FFBB28'];
      const RADIAN = Math.PI / 180;
      const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);
        const value = filteredData[index].value;
        return (
          <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
            {value}
          </text>
        );
      };
      const CustomLegend_Pie = () => (
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px' }}>
          {filteredData.map((entry, index) => (
            <div key={entry.name} style={{ display: 'flex', alignItems: 'center', marginRight: '20px' }}>
              <span style={{ width: '12px', height: '12px', backgroundColor: COLORS[index] }}></span>
              {entry.name}
            </div>
          ))}
        </div>
      );
   
      const dataLineChart_Employeeturnover = 
      social && social.quarterlyEmployeeTurnAroundTrend.map((item) => (
        { name: item.quarter, uv: item.turnover}
      ));
      console.log(dataLineChart_Employeeturnover);
      const dataLineChart_Fatalities = 
      social && social.annualFatalitiesTrend.map((item) => (
        { name: item.year, uv: item.fatalities}
      ));
      
      // Code for Bar Chart Employees by employment type and gender Start
      const dataBarChart_Stack = 
        social && social.employeesByEmploymentTypeAndGender.map((item) => (
          { category: item.employmentType, Male: item.maleCount, Female: item.femaleCount, Others: item.othersCount, NotReported: 0 }
        ))
      const keys = ['Male', 'Female', 'Others', 'NotReported']; // List of genders
      const COLORS_Stack = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042']; // Colors for different genders
      // Code for Bar Chart Employees by employment type and gender End

      // Code for Bar Chart Employees by region and employment type Start
      const dataBarChart_Stack_region = 
      social && social.employeesByRegionAndEmploymentType.map((item) => ({
        category: item.Region,
        Nonguaranteedhrsemployees: item['non-guaranteed-hours'],
        Fulltimeemployees: item['full-time'],
        Parttimeemployees: item['part-time'],
        Onsiteemployees: item['on-site']
      }));
      const keys_region = ['Nonguaranteedhrsemployees', 'Fulltimeemployees','Parttimeemployees','Onsiteemployees'];
      const COLORS_Stack_region = ['#0088FE', '#00C49F', '#FFBB28','#FF8042','#407775']; 
      // Code for Bar Chart Employees by region and employment type End
      const maxValue_employeeturnover = Math.max(...social && social?.quarterlyEmployeeTurnAroundTrend?.map((item) => item.turnover));
      console.log(maxValue_employeeturnover);
      const yAxisDomain_employeeturnover = [0, Math.ceil(maxValue_employeeturnover / 5) * 5];
      const maxValue = Math.max(...social && social.annualFatalitiesTrend.map((item) => item.fatalities));
      const yAxisDomain = [0, Math.ceil(maxValue / 5) * 5];
      const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
          return (
            <div className="custom-tooltip">
              <p>{`${label}`}</p>
              <ul>
                {payload.map((point, index) => (
                  <li key={index} style={{ color: point.color }}>
                    {`${point.name}: ${point.value} (${point.payload.uv}% )`}
                  </li>
                ))}
              </ul>
            </div>
          );
        }
        return null;
      };
     
      
      
      const data_map = 
      social && social.employeesByCountry.map((item) => (
        { country: item.country, value: item.employeeCount}
      ))
  
  const handleLegalChange = (selectedLegal) => {
    setLegal(selectedLegal);
    fetchSocial();
  };

  const handleBusinessChange = (selectedBusiness) => {
    setBusiness(selectedBusiness);
    fetchSocial();
  };

  const handleCountryChange = (selectedCountry) => {
    console.log(selectedCountry);
    setCountry(selectedCountry);
  };

  const handleSiteChange = (selectedSite) => {
    setSite(selectedSite);
  };

  const handleYearChange = (selectedYear) => {
    setYear(selectedYear);
  };
  const renderHeader = () => {
    const loginType = localStorage.getItem('loginType');
    if (loginType === 'AAD') {
      return <AADHeader />;
    }
    return <LoginHeader heading="" />;
  };
    return (
<div id="wrapper">
      <div id="sidebar-wrapper" className={isOpen ? "sidebar-open" : "sidebar-close"}>
        <SideNavigation getOpen={getOpen} />
      </div>
      <div id="page-content-wrapper" className={isOpen ? "" : "page-content-wrapper-pd-0"}>
       {renderHeader()}

        {/* Rest of your existing JSX content */}
        <div className="row mt-25 pd-lr-50">
         <div className="col-md-2">
          <label class="formlable" for="inputState">Legal entity </label>
          <select id="inputState" class="Ecodropdown" required onChange={(e) => handleLegalChange(e.target.value)}>
            <option selected value="">Select </option>
            {activeetities && activeetities.map((status) => (
              <option key={status.name} value={status.name}>{status.name}</option>
            ))}
          </select>
         </div>
         <div className="col-md-2">
            <label class="formlable" for="inputState">Business unit </label>
            <select id="inputState" class="Ecodropdown" required onChange={(e) => handleBusinessChange(e.target.value)}>
              <option selected value="">Select </option>
              {businessunit && businessunit.map((status) => (
                <option key={status.name} value={status.name}>{status.name}</option>
              ))}
            </select>
         </div>
         <div className="col-md-2">
            <label class="formlable" for="inputState">Country</label>
            <select id="inputState" class="Ecodropdown" required onChange={(e) => handleCountryChange(e.target.value)}>
              <option selected value="">Select </option>
              {countries && countries.map((status) => (
                <option key={status} value={status}>{status}</option>
              ))}
            </select>
         </div>
         <div className="col-md-2">
            <label class="formlable" for="inputState">Site location</label>
            <select id="inputState" class="Ecodropdown" required onChange={(e) => handleSiteChange(e.target.value)}>
              <option selected value="">Select </option>
              {activesite && activesite.map((status) => (
                <option key={status.name} value={status.name}>{status.name}</option>
              ))}
            </select>
         </div>
         <div className="col-md-2">
            <label class="formlable" for="inputState">Year</label>
            <select id="inputState" class="Ecodropdown" required onChange={(e) => handleYearChange(e.target.value)}>
              <option selected value="">Select</option>
              <option value="2022">2022</option>
              <option value="2023">2023</option>
              <option value="2024">2024</option>
            </select>
         </div>
         <div className="col-md-2">
         <label class="formlable" for="inputState">Emp category </label>
                  <select id="inputState" class="Ecodropdown" required >
                    <option selected value="">Select</option>
                    <option  value="">L1</option>
                    <option value="">L2</option>
                    <option value="">L3</option>
                    <option value="">L4</option>
                  </select>
         </div>
         </div>
        
            <div className="row mt-25 mb-25 pd-lr-50">
              <div className="col-md-2">
             <div className="employee-box">
             <div className="employee-box-content">{social.totalEmployees}</div>
             <div className="employee-box-header">Total employees</div>
             </div>
             </div>
             <div className="col-md-2">
             <div className="employee-box">
             <div className="employee-box-content">{yearr}</div>
             <div className="employee-box-header">Gender distribution (Male:Female:Other)</div>
            </div>
             </div>
             <div className="col-md-2">
             <div className="employee-box">
             <div className="employee-box-content">{social.employeeTurnoverRate}%</div>
             <div className="employee-box-header">Employee turnover rate</div>
             </div>
             </div>
             <div className="col-md-2">
             <div className="employee-box">
             <div className="employee-box-content">{social.employeesWithDisabilitiesPercentage}%</div>
             <div className="employee-box-header">Employees with disabilities</div>
             </div>
             </div>
             <div className="col-md-2">
             <div className="employee-box">
             <div className="employee-box-content">{social.employeesEntitledToFamilyLeavesPercentage}%</div>
             <div className="employee-box-header">Employees entitled to family related leaves</div>
            </div>
             </div>
             <div className="col-md-2">
             <div className="employee-box">
             <div className="employee-box-content">{social.averageTrainingHoursPerEmployee}</div>
             <div className="employee-box-header">Average hrs of skill training per employee</div>
             </div>
             </div>
        
        </div>
        <div className="row pd-lr-50">
          <div className="col-md-6">
          <div className="charts">
          <h5 style={{ textAlign: 'center',fontSize: '15px' }}>Employee by countries</h5>
            {social ? (
              <WorldMap
                color="green"
                title=""
                value-suffix="employees"
                size="md"
                data={data_map}
                width={600} // Set the desired width
                height={500} // Set the desired height
              />
            ):(<p></p>)}
            </div>
          </div>
          <div className="col-md-6">
          <div className="charts">
            <h5 style={{ textAlign: 'center',fontSize: '15px' }}>Employee age distribution</h5>
            <ResponsiveContainer width="100%" height={300}>
              {social ? (
                <PieChart width={400} height={400}>
                  <Pie
                    data={filteredData}
                    cx="50%"
                    cy="50%"
                    labelLine={false}
                    label={renderCustomizedLabel}
                    outerRadius={80}
                    fill="#8884d8"
                    dataKey="value"
                  >
                    {filteredData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                  </Pie>
                  <Legend content={<CustomLegend_Pie />} align="center" verticalAlign="bottom" />
                </PieChart>
              ): (
                <p></p>
              )}
            </ResponsiveContainer>
            </div>
          </div>
          </div>
          <div className="row mt-25 mb-25 pd-lr-50">
          <div className="col-md-6">
          <div className="charts">
            <div class="table-responsive-social">
                <table class="custom-table-social">
                <tr>
                <th>Employees Wages</th>
            
              </tr>
              <tr>
                <td>Male-female pay gap</td>
                <td>{social?.maleFemalePayGap || 0}%</td>
              </tr>
              <tr>
                <td>Annual compensation ratio</td>
                <td>{social?.annualCompensationRatio || 0}%</td>
              </tr>
              <tr>
                <td>Employees with inadequate wages</td>
                <td>{social?.employeesWithInadequateWages}%</td>
              </tr>
          </table>
            </div>
            </div>
          </div>
          <div className="col-md-6">
          <div className="charts">
        <div class="table-responsive-social">
         <table class="custom-table-social">
          <tr>
            <th>Health and safety	</th>
        
           </tr>
           <tr>
              <td>Work related fatalities</td>
              <td>{social?.workRelatedFacilities || 0}</td>
           </tr>
           <tr>
            <td>Work related accidents</td>
            <td>{social?.workRelatedAccidents || 0}</td>
           </tr>
           <tr>
             <td>No. of work days lost to work related ill-health, accidents and fatalities</td>
             <td>{social?.numberOfWorkDaysLost || 0}</td>
           </tr>
           <tr>
             <td>Severe human rights incidents</td>	
             <td>{social?.severeHumanRightIncidents || 0}</td>
           </tr>
           <tr>
             <td>Harassment incidents</td>
             <td>{social?.workRelatedFacilities || 0}</td>
           </tr>
           <tr>
              <td>Total fines paid for violating social and human rights</td>
             <td>EUR {social?.totalFinesPaidForViolatingHumanAndSocialRights || 0}</td>
           </tr>	
          </table>
        </div>
        </div>
        </div>
        </div>
        <div className="row mt-25 mb-25 pd-lr-50">
            <div className="col-md-6">
            <div className="charts">
            <h5 style={{ textAlign: 'center',fontSize: '15px' }}>Employee age distribution</h5>
            <ResponsiveContainer width="100%" height={400}>
            {social ? (
                <LineChart
                  width={500}
                  height={400}
                  data={dataLineChart_Employeeturnover}
                  margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" tick={{ fontSize: 12 }} />
                  <YAxis
                  ticks={[...Array(Math.ceil(maxValue_employeeturnover / 5) + 1).keys()].map((tick) => tick * 5)}
                  domain={yAxisDomain_employeeturnover}
                  tickFormatter={(value) => `${value}%`}
                  label={{
                    value: 'Employee turnover',
                    angle: -90,
                    position: 'insideLeft',
                    offset: -5,
                    fontSize: 12,
                  }}
                  tick={{ fontSize: 12 }}
                  />
                  <Tooltip />
                  
                  {/* <Line type="linear" dataKey="uv" stroke="#407775" dot={false} /> */}
                  <Line
                  type="linear"
                  dataKey="uv"
                  stroke="#407775"
                  dot={false}
                  label={{
                    position: 'top',
                    content: ({ x, y, value }) => (
                      <text x={x} y={y} dy={-5} fill="#407775" fontSize={10} textAnchor="middle">
                        {`${value}%`}
                      </text>
                    ),
                  }}
                  />
                </LineChart>
            ):(<p></p>)}
            </ResponsiveContainer>
            </div>
            </div>

     <div className="col-md-6">
     <div className="charts">
     <h5 style={{ textAlign: 'center',fontSize: '15px' }}>Employee age distribution</h5>
            <ResponsiveContainer width="100%" height={400}>
            {social ? (
              <LineChart
            width={500}
            height={400}
            data={dataLineChart_Fatalities}
            margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
            }}
            >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" tick={{ fontSize: 12 }} />
          <YAxis
            ticks={[...Array(Math.ceil(maxValue / 5) + 1).keys()].map((tick) => tick * 5)}
            domain={yAxisDomain}
            label={{
              value: 'Fatalities',
              angle: -90,
              position: 'insideLeft',
              offset: -5,
              fontSize: 12,
            }}
            tick={{ fontSize: 12 }}
          />
          <Tooltip />
          
          <Line type="linear" dataKey="uv" stroke="#407775" dot={false} />
          <Line
            type="linear"
            dataKey="uv"
            stroke="#407775"
            dot={false}
            label={{
              position: 'top',
              content: ({ x, y, value }) => (
                <text x={x} y={y} dy={-5} fill="#407775" fontSize={10} textAnchor="middle">
                  {value}
                </text>
              ),
              }}
            />
              </LineChart>
            ):(<p></p>)}
            </ResponsiveContainer>
         
            </div>
   </div>
      </div>
        <div className="row mt-25 mb-25 pd-lr-50">
            <div className="col-md-6">
              <div className="charts">
              <h5 style={{ textAlign: 'center',fontSize: '15px' }}>Employees by employment type and gender</h5>
              <div style={{ marginBottom: '20px' }}>
                <ResponsiveContainer width="100%" height={400}>
                {social ? (
                  <BarChart
                    width={500}
                    height={400}
                    data={dataBarChart_Stack}
                    margin={{ top: 20, right: 30, left: 20, bottom: 60 }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                      dataKey="category"
                      angle={-20}
                      textAnchor="end"
                      interval={0}
                      tick={{ fontSize: 10 }} // Adjust the font size for the X-axis labels
                    />
                    <YAxis 
                      label={{
                          value: 'Employees',
                          angle: -90,
                          position: 'insideLeft',
                          offset: -10,
                          fontSize: 12, // Adjust the font size for the Y-axis label
                        }}
                    />
                    <Tooltip />
            
                    {keys.map((key, index) => (
                      <Bar key={key} dataKey={key} stackId="gender" fill={COLORS_Stack[index]} barSize={30} />
                      // Adjust 'barSize' prop to set the width of bars
                    ))}
                    <Legend
                      layout="horizontal" // Display legend items horizontally
                      align="center" // Align the legend to the center
                      verticalAlign="top" // Position the legend above the bars
                      wrapperStyle={{ fontSize: 12, marginBottom: '10px' }} 
                    />
                  </BarChart>
                ):(<p></p>)}
                </ResponsiveContainer>

              </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="charts">
              <h5 style={{ textAlign: 'center',fontSize: '15px' }}>Employees by region and employment type</h5>
             
              <div style={{ marginBottom: '20px' }}>
                <ResponsiveContainer width="100%" height={400}>
               
                  <BarChart
                    width={500}
                    height={400}
                    data={dataBarChart_Stack_region}
                    margin={{ top: 20, right: 30, left: 20, bottom: 60 }} // Adjust bottom margin to accommodate rotated labels
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                      dataKey="category"
                      angle={-20}
                      textAnchor="end"
                      interval={0}
                      tick={{ fontSize: 10 }} // Adjust the font size for the X-axis labels
                    />
                    <YAxis
                      label={{
                        value: 'Employees',
                        angle: -90,
                        position: 'insideLeft',
                        offset: -10,
                        fontSize: 12, // Adjust the font size for the Y-axis label
                      }}
                    />
                    <Tooltip />
                    
                    {keys_region.map((key, index) => (
                      <Bar
                        key={key}
                        dataKey={key}
                        stackId="gender"
                        fill={COLORS_Stack_region[index]}
                        barSize={30} // Adjust 'barSize' prop to set the width of bars
                      />
                    ))}
                     <Legend
                      layout="horizontal" // Display legend items horizontally
                      align="center" // Align the legend to the center
                      verticalAlign="top" // Position the legend above the bars
                      wrapperStyle={{ fontSize: 12, marginBottom: '10px' }} 
                    />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
            </div>
        </div>
      </div>
    </div>
  );
}
